export enum STORAGE_ENUM {
  TOKEN = 'Swopyn-AUTH-TOKEN',
  USER = 'Swopyn-AUTH-USER',
  CUSTOMER = 'Swopyn-AUTH-CUSTOMER',
  PORTAL_USER_ID = 'Swopyn-AUTH-PORTAL-USER-ID',
  COMPANY = 'Swopyn-AUTH-COMPANY',
}
